// extracted by mini-css-extract-plugin
module.exports = {"productDescriptionBody":"HowToUseSideDrawer_productDescriptionBody__2E9fi"};